import { handleApiError } from 'utils/api_error_handler';
import { notifyWelcomeChecklist } from 'components/welcome_checklist';

export default class Study {
  static resources = [
    'lessons',
    'teachers',
    'comments',
    'question_comments',
    'answers'
  ];

  static track(
    resourceType,
    successCallback = () => {},
    errorCallback = () => {}
  ) {
    Thor.Question.check_limits(
      { id: currentUser.id },
      { data: { component_name: resourceType } }
    )
      .then(response => {
        successCallback(response);

        if (Study.resources.includes(resourceType)) {
          Study.notifyBenefitsFeatures();
          Study.updateWelcomeChecklist(resourceType);
        }
      })
      .catch(error => {
        if (error) {
          handleApiError(null, error?.response ?? error);
          errorCallback(error);
        }
      });
  }

  static trackWithoutCheckLimits(resourceType) {
    if (!Study.resources.includes(resourceType)) {
      return;
    }

    Study.notifyBenefitsFeatures();
    Study.updateWelcomeChecklist(resourceType);
  }

  static notifyBenefitsFeatures() {
    if (window.callBenefitsWeeklyModal) {
      window.callBenefitsWeeklyModal();
    }

    if (window.updateBenefitsStudyDays) {
      window.updateBenefitsStudyDays();
    }
  }

  static updateWelcomeChecklist(resourceType) {
    let resource = resourceType;

    if (resource === 'question_comments') {
      resource = resource.replace('question_', '');
    }

    notifyWelcomeChecklist(resource);
  }
}
